import React from "react";
import MediaGridItem from "./components/MediaGridItem";
import MediaAudioItem from "./components/MediaAudioItem";

export default function MediaSection({ slug, title, items }) {
  return (
    <section id={slug} className={"show-page-section "}>
      <h3 className={"show-page-section-title"}>{title}</h3>

      {slug === "audio" ? (
        <div>
          {items.map((item, index) => (
            <MediaAudioItem key={index} item={item} />
          ))}
        </div>
      ) : (
        <div className={"show-page-section-grid"}>
          {items.map((item, index) => (
            <MediaGridItem
              key={index}
              index={index}
              mediaSection={slug}
              item={item}
            />
          ))}
        </div>
      )}
    </section>
  );
}
